import React from 'react';
import ReplayIcon from '@mui/icons-material/Replay';

export const RefetchButton: React.FC<{
  className?: string;
  onClick: () => void;
  ariaLabel?: string;
}> = ({ className, onClick, ariaLabel }) => {
  return (
    <button
      style={{ background: 'var(--c-button-background)' }}
      className={
        'rounded-[300px] ' +
        'h-8 ' +
        'w-8 ' +
        'text-[--c-button-text] ' +
        'mx-5 ' +
        'focus:outline-none ' +
        'focus:ring-2 ' +
        'focus:ring-[--c-primary-color] ' +
        'disabled:bg-gray-400 ' +
        'disabled:cursor-not-allowed ' +
        (className || '')
      }
      onClick={onClick}
      onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--c-button-background-hover)')}
      onMouseLeave={(e) => (e.currentTarget.style.background = 'var(--c-button-background)')}
      aria-label={ariaLabel}
    >
      <ReplayIcon />
    </button>
  );
};
